import { useState, useEffect, useMemo } from "react";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Info } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { PlayCircleFilled } from "@mui/icons-material";
import { Avatar } from "@mui/material";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Stack,
  Chip,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery
} from "@mui/material";

import {
  Description,
  Download,
  VideoCall,
  CalendarToday,
  AccessTime,
  Star
} from "@mui/icons-material";

function BookingSystem({ currentUser, onLogout }) {
 const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
const API_URL = `${process.env.REACT_APP_API_URL}/bookings`;
  const userEmail =
    currentUser && typeof currentUser === "object"
      ? currentUser.email
      : currentUser;

  const username = currentUser?.username || userEmail?.split("@")[0];

  const [selectedDate, setSelectedDate] = useState(null);
  const [level, setLevel] = useState("");
  const [time, setTime] = useState("");
  const [bookedSlots, setBookedSlots] = useState([]);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
const [videos, setVideos] = useState([]);
const [openVideos, setOpenVideos] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarColor, setSnackbarColor] = useState("#4caf50");
const [bookingLoading, setBookingLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [openDocs, setOpenDocs] = useState(false);
const [meetAnchor, setMeetAnchor] = useState(null);
  const [page, setPage] = useState(1);
  
  const bookingsPerPage = 3;
  const teachers = [
  {
    id: 1,
    name: "Awin B",
    avatar: "/Awin.jpeg",
    times: ["07:00","09:00","11:00","14:00","16:00","18:00","20:00"]
  },
  {
    id: 2,
    name: "Jesna J",
    avatar: "/jesna.png",
    times: ["08:00","09:00","10:00","11:00","12:00","18:00"]
  }
];

  const timeSlots = [
    "07:00",
    "08:00",
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "14:00",
    "18:00",
    "19:00",
    "20:00"
  ];
const meetLinks = {
  A1: "https://meet.google.com/akj-wzxd-ejn",
  A2: "https://meet.google.com/akj-wzxd-ejn",
  B1: "https://meet.google.com/hcz-dwbe-dgn",
  B2: "https://meet.google.com/hcz-dwbe-dgn"
};


useEffect(() => {

  if (!currentUser) return;

  const userId = currentUser?.id || currentUser?._id;

  if (!userId) return;

  fetch(`${process.env.REACT_APP_API_URL}/users/${userId}/documents`)
    .then(res => res.json())
    .then(data => {
      setDocuments(data);
    })
    .catch(err => console.error("Document fetch error:", err));

}, [currentUser]);

const showMessage = (message, color = "#4caf50") => {
  if (isMobile) {
    alert(message);
  } else {
    setSnackbarMessage(message);
    setSnackbarColor(color);
    setSnackbarOpen(true);
  }
};
useEffect(() => {
  if (bookedSlots.length > 0) {
    // pick latest booking date
    const latest = [...bookedSlots].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    )[0];

    setSelectedDate(latest.date);
  }
}, [bookedSlots]);

useEffect(() => {
  if (!currentUser) return;

  const userId = currentUser?.id || currentUser?._id;

  fetch(`${process.env.REACT_APP_API_URL}/users/${userId}/videos`)
    .then(res => res.json())
    .then(data => setVideos(data))
    .catch(err => console.error(err));

}, [currentUser]);


  const getWeekStartEndStr = (dateStr) => {

    const date = new Date(dateStr);
    const day = date.getDay();
    const diffToMonday = day === 0 ? -6 : 1 - day;

    const monday = new Date(date);
    monday.setDate(date.getDate() + diffToMonday);

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    const toYMD = (d) => d.toISOString().split("T")[0];

    return {
      startStr: toYMD(monday),
      endStr: toYMD(sunday)
    };

  };

 useEffect(() => {
  fetchBookings();
}, []);

  const fetchBookings = async () => {

    try {

      const res = await fetch(API_URL);
      const data = await res.json();

      const cleaned = data.map((b) => ({
        _id: b._id,
        username: b.username || b.email?.split("@")[0],
        email: b.email,
        level: b.level,
        date: b.date,
        time: b.time
      }));

      setBookedSlots(cleaned);

      setCalendarEvents(
  cleaned.map((b) => ({
    id: b._id, // ⭐ IMPORTANT
    title: b.level,
    start: `${b.date}T${b.time}:00`,
    display: "block",
    color:
      new Date(`${b.date}T${b.time}`) <= new Date()
        ? "#b0b0b0"
        : b.email === userEmail
        ? "#4caf50"
        : "#ff4d4d"
  }))
);

    } catch (err) {
      console.error(err);
    }

  };


  useEffect(() => {

    const userBookings = bookedSlots.filter(
      (b) => b.email === userEmail
    );

    const totalPages = Math.ceil(userBookings.length / bookingsPerPage);

    if (page > totalPages && totalPages > 0) {
      setPage(totalPages);
    }

  }, [bookedSlots]);

const availableTimes = useMemo(() => {
  if (!selectedDate) return [];

  const now = new Date();
  const todayStr = now.toISOString().split("T")[0];

  // ❌ block past dates
  if (selectedDate < todayStr) return [];

  return timeSlots.filter((t) => {

    // ❌ 1. SAME USER cannot book same time again
    const alreadyBookedByUser = bookedSlots.some(
      (b) =>
        b.date === selectedDate &&
        b.time === t &&
        b.email === userEmail
    );

    if (alreadyBookedByUser) return false;


    // ❌ 3. block past time (today only)
    if (selectedDate === todayStr) {
      const [hours, minutes] = t.split(":").map(Number);

      const slotTime = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        hours,
        minutes
      );

      if (slotTime <= now) return false;
    }

    // ✅ allowed
    return true;
  });

}, [selectedDate, bookedSlots, userEmail, level]);
  const handleDateClick = (info) => {

    const now = new Date();
    const selected = new Date(info.dateStr + "T00:00");

    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    if (selected < today) return;

    const { startStr, endStr } = getWeekStartEndStr(info.dateStr);

    const weeklyCount = bookedSlots.filter(
      (b) =>
        b.email === userEmail &&
        b.date >= startStr &&
        b.date <= endStr
    ).length;

    if (weeklyCount >= 3) {

      showMessage("You cannot book more than 3 slots per week.", "#d4c85f");
      return;

    }

    setSelectedDate(info.dateStr);
    setLevel("");
    setTime("");
    setOpenDialog(true);

  };

 const sendBooking = async () => {
  if (!level || !time || bookingLoading) return;

  setOpenDialog(false);
  setBookingLoading(true);

  const booking = {
    email: userEmail,
    level,
    date: selectedDate,
    time
  };

  // ✅ SHOW SUCCESS IMMEDIATELY (optimistic)
  showMessage(
    `Booking saved for ${selectedDate} at ${time} (${level})`,
    "#4caf50"
  );

  try {
    const res = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(booking)
    });

    const data = await res.json();

    if (!res.ok) {
      showMessage(data.message || "Booking failed", "#ff4d4d");
      return;
    }

    // ✅ Update UI AFTER (background sync)
    await fetchBookings();

  } catch (err) {
    console.error(err);
    showMessage("Server error", "#ff4d4d");
  } finally {
    setBookingLoading(false);
  }
};

  const cancelBooking = async (id) => {

    const bookingToDelete = bookedSlots.find((b) => b._id === id);

    const updatedBookings = bookedSlots.filter((b) => b._id !== id);

    setBookedSlots(updatedBookings);

    const userUpdatedBookings = updatedBookings.filter(
      (b) => b.email === userEmail
    );

    const newTotalPages = Math.ceil(userUpdatedBookings.length / bookingsPerPage);

    if (page > newTotalPages && newTotalPages > 0) {
      setPage(newTotalPages);
    }

    setCalendarEvents((prev) =>
  prev.filter((e) => e.id !== id)
);

    setSnackbarMessage("Booking deleted successfully");
    try {

      await fetch(`${API_URL}/${id}`, {
        method: "DELETE"
      });

    } catch (err) {

      console.error(err);
      fetchBookings();

    }

  };

  const userBookings = bookedSlots.filter(
    (b) => b.email === userEmail
  );

  const totalPages = Math.ceil(userBookings.length / bookingsPerPage);

  const paginatedBookings = userBookings.slice(
    (page - 1) * bookingsPerPage,
    page * bookingsPerPage
  );
 const handleEventClick = (info) => {
  const event = info.event;

  const date = event.startStr.split("T")[0];
  const { startStr, endStr } = getWeekStartEndStr(date);

  const weeklyCount = bookedSlots.filter(
    (b) =>
      b.email === userEmail &&
      b.date >= startStr &&
      b.date <= endStr
  ).length;

  if (weeklyCount >= 3) {
    showMessage("You cannot book more than 3 slots per week.", "#d4c85f");
    return;
  }

  const time = event.startStr.split("T")[1].slice(0,5);

  setSelectedDate(date);
  setTime(time);
  setLevel(event.title);
  setOpenDialog(true);
};

const getThumbnail = (url) => {
  try {
    const videoId =
      url.split("v=")[1]?.split("&")[0] || // youtube.com
      url.split("youtu.be/")[1]?.split("?")[0] || // short link
      url.split("shorts/")[1]?.split("?")[0]; // shorts

    return videoId
      ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
      : null;
  } catch {
    return null;
  }
};

return (

<Box
  sx={{
    minHeight: "100vh",
    background: "#5c0000", // full dark red
    py: 2,
    boxShadow: "inset 0 0 120px rgba(0,0,0,0.6)" // dark shadow effect
  }}
>
  <Box
    sx={{
      maxWidth: 1200,
      mx: "auto",
      px: { xs: 1.5, sm: 2, md: 3 },
      py: { xs: 2, md: 3 },
      borderRadius: 3,
      backdropFilter: "blur(8px)",
      background: "rgba(255,255,255,0.95)",
      boxShadow: "0 20px 50px rgba(0,0,0,0.4)"
    }}
  >
      {/* HEADER */}

      <Stack
  direction={{ xs: "column", sm: "row" }}
  justifyContent="space-between"
  alignItems={{ xs: "flex-start", sm: "center" }}
  spacing={{ xs: 2, sm: 0 }}
  mb={3}
>

  {/* LEFT SIDE */}
  <Stack direction="row" alignItems="center" spacing={2}>
    <Box
      component="img"
      src="/logo.png"
      alt="logo"
      sx={{
        height: { xs: 60, sm: 80, md: 110 }
      }}
    />

    <Typography variant="h6" color="primary" fontWeight="bold">
      Welcome, {username} 👋
    </Typography>
  </Stack>

  {/* RIGHT SIDE BUTTON GRID */}
  <Box
    sx={{
      width: { xs: "100%", sm: "auto" },
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr 1fr",                 // 📱 2 per row
        sm: "auto auto auto auto auto" // 💻 5 inline
      },
      gap: 1.5,
      mt: { xs: 1, sm: 0 }
    }}
  >
    {/* MEET */}
    <Button
      variant="outlined"
      startIcon={<VideoCall />}
      onClick={(e) => setMeetAnchor(e.currentTarget)}
      sx={{ width: "100%", height: 42 }}
    >
      Meet
    </Button>

    {/* VIDEOS */}
    <Button
      variant="outlined"
      startIcon={<PlayCircleFilled />}
      onClick={() => setOpenVideos(true)}
      sx={{ width: "100%", height: 42 }}
    >
      Videos
    </Button>

    {/* MATERIALS */}
    <Button
      variant="outlined"
      startIcon={<Description />}
      onClick={() => setOpenDocs(true)}
      sx={{ width: "100%", height: 42 }}
    >
      Materials
    </Button>
 {/* INFO */}
    {isMobile ? (
      <Button
        variant="outlined"
        startIcon={<Info />}
        sx={{ width: "100%", height: 42 }}
        onClick={() =>
          alert(
            "📅 Select a date\n🎓 Choose level & time\n⚠️ Max 3 bookings/week\n📄 Download materials\n🎥 Join via Meet"
          )
        }
      >
        Info
      </Button>
    ) : (
      <Tooltip
  arrow
  placement="top"
  title={
    <Box sx={{ fontSize: 13, lineHeight: 1.6, color: "#000" }}>
      <strong>How to use the booking system</strong>
      <br />
      📅 Select a date from the calendar <br />
      🎓 Choose your level and available time <br />
      ⚠️ Maximum 3 bookings per week <br />
      📄 Download learning materials anytime <br />
      🎥 Join the class using the Meet button
    </Box>
  }
  componentsProps={{
    tooltip: {
      sx: {
        bgcolor: "#fff",   // ✅ white background
        color: "#000",     // ✅ black text
        boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        borderRadius: 2,
        p: 1.5
      }
    },
    arrow: {
      sx: {
        color: "#fff" // ✅ arrow matches white background
      }
    }
  }}
>
  <Button
    variant="outlined"
    startIcon={<Info />}
    sx={{ width: "100%", height: 42 }}
  >
    Info
  </Button>
</Tooltip>
    )}
    {/* LOGOUT */}
    <Button
      variant="outlined"
      color="error"
      onClick={onLogout}
      sx={{ width: "100%", height: 42 }}
    >
      Logout
    </Button>

   
  </Box>

</Stack>

      {/* MAIN LAYOUT */}

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 3,
          alignItems: "stretch"
        }}
      >

        {/* CALENDAR */}

        <Paper
          sx={{
            flex: 2,
            p: { xs: 1, sm: 2 },
            overflowX: "auto",
          }}
        >

  <FullCalendar
  plugins={[dayGridPlugin, interactionPlugin]}
  initialView="dayGridMonth"
  dateClick={handleDateClick}
  eventClick={handleEventClick}
  events={calendarEvents}
  height="auto"

  eventTimeFormat={{
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }}

 dayMaxEvents={isMobile ? 2 : 2}

  headerToolbar={
    isMobile
      ? {
          left: "prev,next",
          center: "title",
          right: "today"
        }
      : {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,dayGridWeek"
        }
  }

  validRange={{
    start: new Date().toISOString().split("T")[0]
  }}
/>

        </Paper>

        {/* BOOKINGS PANEL */}

     {/* RIGHT SIDE PANEL */}
<Box
  sx={{
    width: { xs: "100%", md: 320 },
    display: "flex",
    flexDirection: "column",
    gap: 2
  }}
>
  

  {/* AVAILABILITY */}
  <Paper sx={{ p: 2 }}>
    <Typography
  variant="h6"
  sx={{
    color: "#1976d2",
    fontWeight: 700,
    mb: 2
  }}
>
  Available Time
</Typography>
    <Stack spacing={2}>
  {teachers.map((teacher) => (
    <Box
      key={teacher.id}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        borderBottom: "1px solid #eee",
        pb: 1.5
      }}
    >
      {/* TOP: Avatar + Name */}
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Avatar src={teacher.avatar} />

        <Typography
          variant="body2"
          fontWeight={600}
          sx={{ lineHeight: 1.2 }}
        >
          {teacher.name}
        </Typography>
      </Stack>

      {/* TIMES */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1
        }}
      >
        {teacher.times.map((t) => {
  if (!selectedDate) return null;

const todayStr = new Date().toISOString().split("T")[0];

const bookingsAtSlot =
  selectedDate === todayStr
    ? bookedSlots.filter(
        (b) =>
          b.date === selectedDate &&
          b.time === t
      )
    : [];
  const slotCount = bookingsAtSlot.length;

  const isBookedByUser = bookingsAtSlot.some(
    (b) => b.email === userEmail
  );

  return (
    <Chip
  key={t}
  label={
    isBookedByUser
      ? `${t} (You)`
      : slotCount > 0
      ? `${t} (${slotCount})`
      : t
  }
  size="small"
  clickable
 onClick={() => {
  if (!selectedDate) {
    showMessage("Please select a date first", "#ff9800");
    return;
  }

  // ✅ SIMPLE WEEK CHECK
  const { startStr, endStr } = getWeekStartEndStr(selectedDate);

  const weeklyCount = bookedSlots.filter(
    (b) =>
      b.email === userEmail &&
      b.date >= startStr &&
      b.date <= endStr
  ).length;

  if (weeklyCount >= 3) {
    showMessage("You cannot book more than 3 slots per week.", "#d4c85f");
    return;
  }

  setTime(t);
  setOpenDialog(true);
}}
  sx={{
    minWidth: 85,
    justifyContent: "center",
    fontWeight: 600,

    // 🎨 CUSTOM COLORS
    bgcolor: isBookedByUser ? "#ffebee" : "#e8f5e9",
    color: isBookedByUser ? "#c62828" : "#2e7d32",

    border: isBookedByUser
      ? "1px solid #ef5350"
      : "1px solid #81c784",

    // ✨ subtle glow for your slot
    boxShadow: isBookedByUser
      ? "0 0 8px rgba(198,40,40,0.3)"
      : "none",

    "&:hover": {
      bgcolor: isBookedByUser ? "#ffcdd2" : "#c8e6c9"
    }
  }}
  variant="filled"
/>
  );
})}
      </Box>
    </Box>
  ))}
</Stack>
  </Paper>

  {/* YOUR BOOKINGS */}
  <Paper
    sx={{
      width: "100%",
      p: 3,
      bgcolor: "#ffffff",
      display: "flex",
      flexDirection: "column",
      height: { xs: "auto", md: 410 }
    }}
  >
    <Typography variant="h6" mb={2} color="primary" fontWeight="bold">
      Your Bookings
    </Typography>

    {userBookings.length > 0 ? (
      <>
        <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
          <Stack spacing={2}>
            {paginatedBookings.map((b) => (
              <Paper key={b._id} sx={{ p: 2 }}>
                <Stack spacing={1}>

                  <Stack direction="row" spacing={1}>
                    <CalendarToday fontSize="small" />
                    <Typography variant="body2">{b.date}</Typography>
                  </Stack>

                  <Stack direction="row" spacing={1}>
                    <AccessTime fontSize="small" />
                    <Typography variant="body2">{b.time}</Typography>
                  </Stack>

                  <Stack direction="row" spacing={1}>
                    <Star fontSize="small" />
                    <Chip label={b.level} size="small" color="success" />
                  </Stack>

                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    onClick={() => cancelBooking(b._id)}
                  >
                    Cancel
                  </Button>

                </Stack>
              </Paper>
            ))}
          </Stack>
        </Box>

        {/* PAGINATION */}
        {totalPages > 1 && (
          <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
            <Button
              size="small"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Prev
            </Button>

            {[page, page + 1]
              .filter((p) => p <= totalPages)
              .map((p) => (
                <Button
                  key={p}
                  size="small"
                  variant={page === p ? "contained" : "outlined"}
                  onClick={() => setPage(p)}
                >
                  {p}
                </Button>
              ))}

            <Button
              size="small"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next
            </Button>
          </Stack>
        )}
      </>
    ) : (
      <Typography>No bookings yet</Typography>
    )}
  </Paper>

</Box>

      </Box>
      

      {/* BOOKING DIALOG */}

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="xs"
      >

        <DialogTitle>Book a Slot for {selectedDate}</DialogTitle>

        <DialogContent>

          <TextField
            select
            fullWidth
            label="Level"
            value={level}
            onChange={(e) => setLevel(e.target.value)}
            margin="normal"
          >
            {["A1", "A2", "B1", "B2"].map((l) => (
              <MenuItem key={l} value={l}>{l}</MenuItem>
            ))}
          </TextField>

          <TextField
            select
            fullWidth
            label="Time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            margin="normal"
          >
            {availableTimes.map((t) => (
              <MenuItem key={t} value={t}>{t}</MenuItem>
            ))}
          </TextField>

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setOpenDialog(false)}>Close</Button>

<Button onClick={sendBooking} disabled={!level || !time || bookingLoading}>
  {bookingLoading ? "Booking..." : "Book"}
</Button>

        </DialogActions>

      </Dialog>

      {/* DOCUMENTS DIALOG */}

      <Dialog
        open={openDocs}
        onClose={() => setOpenDocs(false)}
        maxWidth="sm"
        fullWidth
      >

        <DialogTitle>Documents</DialogTitle>

        <DialogContent>

          {documents.length > 0 ? (

            <Stack spacing={2} mt={1}>

              {documents.map((doc) => (

                <Paper
                  key={doc._id}
                  sx={{
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >

                  <Typography>{doc.name}</Typography>

                <Button
  variant="contained"
  size="small"
  startIcon={<Download />}
  href={doc.fileUrl}
  target="_blank"
  download
>
  Download
</Button>

                </Paper>

              ))}

            </Stack>

          ) : (

            <Typography mt={2}>
              No documents available
            </Typography>

          )}

        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDocs(false)}>
            Close
          </Button>
        </DialogActions>

      </Dialog>


   <Dialog
  open={openVideos}
  onClose={() => setOpenVideos(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ fontWeight: "bold" }}>
    Videos
  </DialogTitle>

  <DialogContent>
    {videos.length > 0 ? (
      <Stack spacing={2} mt={1}>

        {videos.map((v, index) => {
          const thumbnail = getThumbnail(v.url);

          return (
            <Paper
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 1.5,
                borderRadius: 2,
                gap: 2,
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#f5f5f5"
                }
              }}
              onClick={() => window.open(v.url, "_blank")}
            >

              {/* THUMBNAIL */}
              {thumbnail ? (
                <Box
                  component="img"
                  src={thumbnail}
                  sx={{
                    width: 120,
                    height: 70,
                    objectFit: "cover",
                    borderRadius: 1
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: 120,
                    height: 70,
                    background: "#ddd",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 1
                  }}
                >
                  No Preview
                </Box>
              )}

              {/* TITLE */}
              <Typography fontWeight="500">
                {v.name}
              </Typography>

            </Paper>
          );
        })}

      </Stack>
    ) : (
      <Typography mt={2}>No videos available</Typography>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenVideos(false)}>Close</Button>
  </DialogActions>
</Dialog>
{/* GOOGLE MEET MENU */}

<Menu
  anchorEl={meetAnchor}
  open={Boolean(meetAnchor)}
  onClose={() => setMeetAnchor(null)}
>

  {Object.entries(meetLinks).map(([level, link]) => (

    <MenuItem
      key={level}
      onClick={() => {
        window.open(link, "_blank");
        setMeetAnchor(null);
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        py: 1.2
      }}
    >

      <VideoCall color="primary" />

      <Box>
        <Typography fontWeight="bold">
          {level} Class
        </Typography>

        <Typography
          variant="caption"
          color="text.secondary"
        >
          Join Google Meet
        </Typography>
      </Box>

    </MenuItem>

  ))}

</Menu>
      {/* SNACKBAR */}

      <Snackbar
  open={snackbarOpen}
  autoHideDuration={3000}
  onClose={() => setSnackbarOpen(false)}
  message={snackbarMessage}
  anchorOrigin={{
    vertical: "top",
    horizontal: "right"
  }}
 sx={{
  mt: isMobile ? 14 : 10, // push down on desktop too
  "& .MuiSnackbarContent-root": {
    backgroundColor: snackbarColor
  }
}}
/>
      

    </Box>

</Box>
  );

}


export default BookingSystem;